var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[_c('Drawer'),_c('v-content',{staticClass:"hide-overflow",staticStyle:{"padding-left":"300px"},attrs:{"id":"mainContent"}},[_c('div',[_c('Hero'),_c('div',{staticClass:"container py-5 px-0 fluid"},[_c('About'),_c('Experience'),_c('Skills'),_c('Portfolio'),_c('Contact')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }